/**
 * @generated SignedSource<<e53327e066f6abfbb3f4adff9d44dd2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SEAT_TYPE = "VIRTUAL" | "COLLABORATOR" | "CORE" | "FULL" | "%future added value";
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PrimaryNavigationRight_viewer$data = {
  readonly id: string;
  readonly sisenseUserId: string | null;
  readonly backendId: number | null;
  readonly unseenNotifications: number | null;
  readonly projectOwner: boolean | null;
  readonly profiles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly seat: SEAT_TYPE | null;
      } | null;
    } | null> | null;
  } | null;
  readonly company: {
    readonly id: string;
    readonly name: string | null;
    readonly useTimeApproval: boolean | null;
    readonly useTimeOffApproval: boolean | null;
    readonly unit4Enabled: boolean | null;
    readonly isUsingProjectAllocation: boolean | null;
    readonly tier: TierType | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationMenu_viewer">;
  readonly " $fragmentType": "PrimaryNavigationRight_viewer";
};
export type PrimaryNavigationRight_viewer$key = {
  readonly " $data"?: PrimaryNavigationRight_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PrimaryNavigationRight_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PrimaryNavigationRight_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sisenseUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unseenNotifications",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "ProfileTypeConnection",
      "kind": "LinkedField",
      "name": "profiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "seat",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "profiles(first:1)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeOffApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit4Enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingProjectAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationMenu_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "478ffe966c5edb778876d9a8e4d6c441";

export default node;
